import { createAsyncThunk } from '@reduxjs/toolkit'
import PaymentInformation from './payment-information-model'
import {
  delete_paymentInformation,
  load_paymentInformations,
  store_paymentInformation,
} from './paymentInformation-service'

export const LoadPaymentInformationsAsync = createAsyncThunk<any, any>(
  'composer/load/paymentInformation',
  async (params: { uid: string }) => {
    return await load_paymentInformations(params)
  },
)

export const CreatePaymentInformationAsync = createAsyncThunk<any, any>(
  'composer/create/paymentInformation',
  async (params: PaymentInformation) => {
    return await store_paymentInformation(params)
  },
)

export const DeletePaymentInformationAsync = createAsyncThunk<any, any>(
  'composer/delete/paymentInformation',
  async (params) => {
    return await delete_paymentInformation(params)
  },
)
